// Fecha o modal só quando o clique COMEÇA e TERMINA no fundo escuro.
// Evita fechar quando o conteúdo muda de altura entre mousedown/mouseup (ex.: troca de aba,
// marcar checkbox) ou ao arrastar seleção de texto para fora do quadro.
export const overlayClose = (onClose) => {
  let armed = false;
  return {
    onMouseDown: (e) => { armed = e.target === e.currentTarget; },
    onClick: (e) => {
      if (armed && e.target === e.currentTarget && typeof onClose === 'function') onClose(e);
      armed = false;
    },
  };
};
